import React from 'react';
import { ShoppingCart, ExternalLink } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const MedicineOrderView = ({ orderingFrom, medicineLinks, onClose }) => {
  if (!orderingFrom || medicineLinks.length === 0) return null;

  return (
    <Card className="p-6 mb-6 bg-gradient-to-r from-blue-50 to-purple-50" data-testid="medicine-order-view">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-2xl font-bold text-blue-800 flex items-center gap-2">
          <ShoppingCart className="w-6 h-6" />Order Medicines from Apollo Pharmacy
        </h2>
        <Button onClick={onClose} variant="outline" size="sm">Close</Button>
      </div>

      <p className="text-gray-600 mb-6">Click on any medicine to view and order from Apollo Pharmacy</p>

      <div className="grid gap-4">
        {medicineLinks.map((medLink, idx) => (
          <div key={`medlink-${idx}`} className="bg-white p-4 rounded-lg border shadow-sm">
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <h3 className="font-bold text-gray-800 text-lg">{medLink.medicine_name}</h3>
                <p className="text-sm text-gray-600 mt-1">{medLink.apollo.pharmacy_name}</p>
              </div>
              <div className="flex flex-col gap-2 items-end">
                <span className="text-green-600 font-semibold">{medLink.apollo.estimated_price}</span>
                <a href={medLink.apollo.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors" data-testid={`order-medicine-${idx}`}>
                  Order from Apollo<ExternalLink className="w-4 h-4" />
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
        <p className="text-sm text-gray-700">
          <strong>Note:</strong> You will be redirected to Apollo Pharmacy website to complete your order. Please verify medicine details and prices on their platform before purchasing.
        </p>
      </div>
    </Card>
  );
};

export default MedicineOrderView;
